import { useContext, useEffect, useState } from 'react';
import AnimateHeight from 'react-animate-height';
import InfiniteScroll from 'react-infinite-scroller';
import { TailSpin } from 'react-loader-spinner';
import { useParams } from 'react-router-dom';

import { BudgetGender, BudgetProductType } from 'types/api/budgets.type';

import { useAppSelector } from 'redux/hooks';

import { budgetDataService } from 'services/budget.service';

import { BudgetContext } from 'contexts';

import { useFetch } from 'hooks';

import { checkParams } from 'helpers/checkParams';

import { Button } from 'components/Button';
import { Table } from 'components/Table';

import { BudgetListSkeleton } from '../../../BudgetListSkeleton';
import { BudgetProduct } from '../../../BudgetProduct';
import * as S from './SingleGender.styles';
import { useColumns } from './columns.data';

type ItemProps = {
  data: BudgetGender;
};

export function SingleGender(props: ItemProps): React.ReactElement {
  const { data } = props;

  const { params, date, addProducts } = useContext(BudgetContext);
  const { id, gender } = useParams();

  const { season, zone, marketLine, warehouse } = useAppSelector((state) => state.settings);

  const [isSubListVisible, isSubListVisibleSet] = useState(false);
  const [slicedCodes, slicedCodesSet] = useState<string[]>([]);
  const [productIds, productIdsSet] = useState<string[]>([]);
  const [codes, codesSet] = useState<string[]>([]);

  const { content, isLoading } = useFetch(
    params && checkParams(params) ? () => budgetDataService.getCodes(params) : undefined,
    [season, zone, marketLine, warehouse, id, gender, params?.type]
  );

  const columns = useColumns(date);

  const iterationAmount = slicedCodes?.length >= 20 ? 20 : slicedCodes.length;
  const hasMore = slicedCodes.length !== 0;

  const getGenderProducts = () => {
    isSubListVisibleSet(!isSubListVisible);

    if (params && checkParams(params)) {
      const slicedArray = slicedCodes.slice(0, iterationAmount);
      slicedCodesSet((state) => {
        state.splice(0, iterationAmount);

        return state;
      });

      if (slicedArray.length > 0) {
        budgetDataService.getProductCode(params, slicedArray).then((res) => {
          addProducts(res.data);
          const ids = res.data.map((item: BudgetProductType) => item.mainProduct.id);
          productIdsSet(ids);
        });
      }
    }
  };

  const addDataOnScroll = () => {
    if (productIds.length === 0) return;

    const slicedArray = slicedCodes.slice(0, iterationAmount);
    slicedCodesSet((state) => {
      state.splice(0, iterationAmount);

      return state;
    });

    if (params && checkParams(params)) {
      budgetDataService.getProductCode(params, slicedArray).then((res) => {
        addProducts(res.data);
        const newIds = res.data.map((item: BudgetProductType) => item.mainProduct.id);
        productIdsSet((state) => [...state, ...newIds]);
      });
    }
  };

  const childrenMapped = productIds.map((productId) => (
    <BudgetProduct key={productId} productId={productId} />
  ));

  useEffect(() => {
    if (codes.length > 0 && slicedCodes.length === 0) {
      slicedCodesSet(codes);
    }
  }, [codes]);

  useEffect(() => {
    if (content) {
      codesSet(content);
    }
  }, [content]);

  if (isLoading) {
    return <BudgetListSkeleton rows={1} withImage={false} columns={5} />;
  }

  return (
    <>
      <S.Container>
        {slicedCodes.length > 0 ? (
          <Button
            data-testid="plus-button"
            iconLeft={isSubListVisible ? 'FiMinus' : 'FiPlus'}
            onClick={() => getGenderProducts()}
          />
        ) : undefined}

        <Table motive="budget" columns={columns} data={data ? [data] : []} />
      </S.Container>

      <AnimateHeight
        data-testid="sub-item-container"
        duration={500}
        height={isSubListVisible ? 'auto' : 0}
      >
        <InfiniteScroll
          hasMore={hasMore}
          loadMore={() => addDataOnScroll()}
          loader={
            <S.LoadingContainer>
              <TailSpin width="100" color="#286090" />
            </S.LoadingContainer>
          }
        >
          {childrenMapped}
        </InfiniteScroll>
      </AnimateHeight>
    </>
  );
}
